import { render } from "./KitchenGarbage.vue?vue&type=template&id=c013f98e&scoped=true"
import script from "./KitchenGarbage.vue?vue&type=script&lang=js"
export * from "./KitchenGarbage.vue?vue&type=script&lang=js"

import "./KitchenGarbage.vue?vue&type=style&index=0&id=c013f98e&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\one-code-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c013f98e"]])

export default __exports__